import React from 'react';
import PropTypes from 'prop-types';

// import ProgressBar from 'components/ProgressBar';

import { testimonials } from 'utils/contentProvider';

import { TestimonialsSection } from './SectionTestimonials.styled';

const SectionTestimonials = ({ isSolutionsPage, title }) => (
  <TestimonialsSection
    style={
      isSolutionsPage ? { backgroundColor: '#ffffff', paddingTop: 10 } : {}
    }
  >
    <div className="container">
      {!isSolutionsPage && (
        <div
          className="rotated-tab-txt pink-rotate-txt"
          style={{ transform: 'none', position: 'static' }}
        >
          <p>Testimonials</p>
        </div>
      )}
      {isSolutionsPage ? (
        <>
          <div className="row align-items-center">
            <div className="col-md-7">
              <h2 className="medium-heading black-txt mt-2">
                {title || `What our customers think about ATC`}
              </h2>
            </div>
            <div className="col-md-5">
              <p className="black-txt" style={{ maxWidth: 440 }}>
                We could tell you the incredible things we do at ATC, but
                instead we thought we’d let our clients speak for themselves.
              </p>
            </div>
          </div>
        </>
      ) : (
        <h2 className="medium-heading black-txt mt-2">
          What Our Clients Say About ATC
        </h2>
      )}
      <div className="row clients">
        {testimonials.map((i) => (
          <div key={i.id} className="col-md-4">
            <div className="client">
              <h3 className="white">{i.comment}</h3>
              <p className="white">{i.author}</p>
            </div>
          </div>
        ))}
      </div>
      {/* <ProgressBar dark /> */}
    </div>
  </TestimonialsSection>
);

SectionTestimonials.propTypes = {
  isSolutionsPage: PropTypes.bool,
  title: PropTypes.string,
};

export default SectionTestimonials;
